
import { State } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Gui } from '../../gui/gui';
import CardsContainer from '../../components/cards/CardsContainer.vue';

@Component({
    components: {
        CardsContainer
    }
})
export default class Overview extends Vue {}
